module.exports = __webpack_public_path__ + "assets/img/myhome_btn_sp.e316204f.svg";